import React, { useState } from 'react';

const Header = () => {
  const [isTouched, setIsTouched] = useState(false);

  return (
    <header
      onTouchStart={() => setIsTouched(true)}
      onTouchEnd={() => setTimeout(() => setIsTouched(false), 300)}
      style={{
        backgroundImage: 'url("/images/temple-banner.jpg.jpeg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '400px',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#ffffff',
        textAlign: 'center',
        backgroundColor: isTouched ? 'rgba(0, 0, 0, 0.4)' : 'transparent',
        transition: 'background-color 0.3s ease',
      }}
    >
      <div style={{ padding: '0 20px' }}>
        <h1
          style={{
            fontFamily: 'Times New Roman, serif',
            fontSize: '2rem',
            margin: '0',
            fontWeight: 'bold',
            textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
          }}
        >
          STHAPATHI
        </h1>
        <p
          style={{
            fontFamily: 'Times New Roman, serif',
            fontSize: '1.3rem',
            marginTop: '10px',
            fontWeight: 'bold',
            textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
          }}
        >
          S.B. KALYANASUNDARAM
        </p>
      </div>
    </header>
  );
};

export default Header;




